// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tSuL","label":"styles_label__1oF4X"};